import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo, Fragment } from 'react';
import { WritingModeProvider as NovaWritingModeProvider, useIsRTL } from '@sas/nova-commons/locale';
import { PopoverManagerProvider } from '@sas/nova-commons/components/Popover/PopoverManager';
import { loadLocalizers } from '../../locale/I18nLoader';
import { I18nProvider } from '../../locale/I18nContext';
import defaultLocalizers from '../../i18n_js/messages';
import messagesManifest from '../../i18n_js/messagesManifest';
import loadingTextBundle from '../../i18n_js/loadingTextBundle';
import defaultLoadingLocalizers from '../../i18n_js/loadingText';
import { getDefaultPopoverRoot, PopoverRootProvider as NovaPopoverRootProvider, } from '@sas/nova-commons/hooks/usePopoverRoot';
import { useLocale, useHonorLocalFormatSettings, useLocaleTextDir } from '../../config';
import { GlobalSettingsProvider } from '@sas/nova-commons/components/Settings';
import { globalSettingsDataProvider } from '../ReportContainer/internal/globalSettingsDataProvider';
import { GlobalSettingsThemeParametersProvider } from '@sas/nova-commons/theme';
export const CoreContextProviders = (props) => {
    return (_jsx(WritingModeProvider, { children: _jsx(PopoverRootProvider, Object.assign({ popoverRootId: props.popoverRootId }, { children: _jsx(LoadI18nProvider, { children: _jsx(PopoverManagerProvider, { children: _jsx(MaybeGlobalSettingsProvider, { children: props.children }) }) }) })) }));
};
const MaybeGlobalSettingsProvider = (props) => {
    const enabled = useHonorLocalFormatSettings();
    return enabled ? (_jsx(GlobalSettingsThemeParametersProvider, { children: _jsx(GlobalSettingsProvider, Object.assign({ dataProvider: globalSettingsDataProvider }, { children: props.children })) })) : (_jsx(Fragment, { children: props.children }));
};
const WritingModeProvider = (props) => {
    const direction = useLocaleTextDir();
    return _jsx(NovaWritingModeProvider, Object.assign({ direction: direction }, { children: props.children }));
};
const LoadI18nProvider = (props) => {
    const [localizers, setLocalizers] = useState(defaultLocalizers);
    const [loadingTextLocalizers, setLoadingLocalizers] = useState(defaultLoadingLocalizers);
    const locale = useLocale();
    useEffect(() => {
        let ignoreResult = false;
        // FIXME: For consistancy with nova and portable we only need to pass in
        // one requested language. The underlying code should be change to accept
        // a string instead of an array.
        const requestedLanguages = [locale];
        loadLocalizers(messagesManifest, requestedLanguages).then((response) => {
            if (ignoreResult) {
                return;
            }
            setLocalizers(response);
        });
        setLoadingLocalizers(loadLocalizers(loadingTextBundle, requestedLanguages));
        return () => {
            ignoreResult = true;
        };
    }, [locale]);
    const value = useMemo(() => ({ localizers, loadingTextLocalizers }), [
        localizers,
        loadingTextLocalizers,
    ]);
    return _jsx(I18nProvider, Object.assign({ value: value }, { children: props.children }));
};
const PopoverRootProvider = (props) => {
    const [popoverRoot, setPopoverRoot] = useState(null);
    const isRTL = useIsRTL();
    useEffect(() => {
        if (!props.popoverRootId) {
            setPopoverRoot(undefined);
            return;
        }
        const popoverRoot = document.getElementById(props.popoverRootId);
        if (!popoverRoot) {
            setPopoverRoot(undefined);
            return;
        }
        setPopoverRoot(popoverRoot);
    }, [props.popoverRootId]);
    useEffect(() => {
        if (popoverRoot === null) {
            return;
        }
        const currPopoverRoot = popoverRoot !== null && popoverRoot !== void 0 ? popoverRoot : getDefaultPopoverRoot(isRTL);
        currPopoverRoot.dir = isRTL ? 'rtl' : 'ltr';
    }, [isRTL, popoverRoot]);
    return _jsx(NovaPopoverRootProvider, Object.assign({ value: popoverRoot }, { children: props.children }));
};
